module.exports = __webpack_public_path__ + "img/5ne.c9a03c44.svg";